<template>
  <div class="amap-choose" v-if="showPlace">
    <div class="top-button">
      <span class="cancel" @click="cancel">取消</span>
      <span class="conform" :style="{ backgroundColor: color }" @click="confrom"
        >完成</span
      >
    </div>
    <div class="map-box">
      <div id="container"></div>
    </div>
    <div class="content">
      <div class="search">
        <div class="input-box">
          <input placeholder="搜索地点" v-model="keyword" />
        </div>
        <span @click="search">搜索</span>
      </div>
      <div class="main">
        <div
          v-for="(item, index) in list"
          :key="index"
          @click="toChecked(item)"
        >
          <div>
            <div>{{ item.title }}</div>
            <span class="detail">{{ item.address }}</span>
          </div>
          <div>
            <span :style="{ color }" v-if="item.id === checked.id">√</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*
	基于腾讯地图的H5端选择地图组件
	* @property {Boolean} value = [false|true] 控制组件显示或隐藏
	* @property {Boolean} exact = [false|true] 是否开启移动端精确定位
	* @property {String} mapkey = '' 腾讯地图开放平台申请的key
	* @event {Function} confirm 确认选择 ,返回选择的位置信息
*/

import { getMapGeocoder, getMapSuggestion, getWebConfig } from "@/api/newApi";
import { Toast } from "vant";
export default {
  props: {
    defaultObj: {
      type: Object,
      default: () => {},
    },
    value: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "#2255D9",
    },
    // mapkey: {
    //   type: String,
    //   default: "Y6JBZ-4FLR3-7IG3S-OZ2ZH-AO7QE-L3FN5",
    // },
    exact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      keyword: "",
      timeId: null,
      checked: {},
      showPlace: false,
      map: {},
      initLoc: [],
      mapkey:'Y6JBZ-4FLR3-7IG3S-OZ2ZH-AO7QE-L3FN5',
    };
  },
  computed: {},
  watch: {
    value: {
      deep: true,
      handler(val) {
        this.showPlace = val;
        val && this.initCurrentLoc();
      },
    },
  },
  created() {
      getWebConfig().then((res) => {
        if (res.data) {
            if(res.data.tencentMapKey){
               this.mapkey = res.data.tencentMapKey;
            }

            var script = document.createElement("script");
            script.type = "text/javascript";
            script.setAttribute("id", "app");
            script.src = `https://map.qq.com/api/gljs?v=1.exp&key=${this.mapkey}`;
            document.body.appendChild(script);
        }
      });

  },
  mounted() {},
  methods: {
    search() {
      getMapSuggestion({
        keyword: this.keyword,
      }).then((res) => {
        if (res.message.code == 0) {
          this.list = res.data.data;
        } else {
          Toast(res.message.message);
        }
      });
    },
    toChecked(e) {
      this.checked = {
        id: e.id,
        adcode: e.adcode,
        city: e.city,
        district: e.district,
        province: e.province,
        location: `${e.location.lat},${e.location.lng}`,
        addressLocal: e.address,
      };
      this.map.setCenter(new TMap.LatLng(e.location.lat, e.location.lng));
      this.addMarker(e.location.lng, e.location.lat);
    },
    cancel() {
      this.$nextTick(() => {
        this.$emit("input", false);
      });
    },
    //完成
    confrom() {
      if (this.checked.location) {
        let address;
        let area;
        if (this.checked.addressLocal) {
          address = this.checked.addressLocal.split(this.checked.district)[1];
          area = `${
            this.checked.province == this.checked.city
              ? this.checked.province
              : this.checked.province + this.checked.city
          }${this.checked.district}`;
        } else {
          address = this.checked.address;
          area = this.checked.area;
        }
        let location = this.checked.location.split(",");
        this.$emit("placeChoose", {
          area,
          address,
          latitude: location[0],
          longitude: location[1],
        });
        this.$emit("input", false);
      } else {
        Toast("请选择点");
      }
    },
    // 初始化当前位置
    initCurrentLoc() {
      this.$nextTick(() => {
        this.getIpLoc();
      });
    },
    async getIpLoc() {
      var center = new TMap.LatLng(39.98412, 116.307484);
      //定义map变量，调用 TMap.Map() 构造函数创建地图
      this.map = await new TMap.Map(document.getElementById("container"), {
        center: center, //设置地图中心点坐标
        zoom: 15, //设置地图缩放级别
      });
      await this.$nextTick(() => {
        if (this.defaultObj.addressLocal) {
          let location = this.defaultObj.location.split(",");
          this.map.setCenter(new TMap.LatLng(location[0], location[1]));
          this.addMarker(location[1], location[0]);
        }
        if (this.defaultObj.mapSearchWorld) {
          this.keyword = this.defaultObj.mapSearchWorld;
        }
        getMapSuggestion({
          keyword: this.keyword || "北京市政府",
        }).then((res) => {
          if (res.message.code == 0) {
            this.list = res.data.data;
            let location = this.list[0].location;
            if (this.map) {
              this.map.setCenter(new TMap.LatLng(location.lat, location.lng));
            }
          } else {
            Toast(res.message.message);
          }
        });
      });
      this.map.on("click", (e) => {
        this.addMarker(e.latLng.lng, e.latLng.lat);
        this.getNowPlace({
          lng: e.latLng.lng,
          lat: e.latLng.lat,
        });
      });
    },

    addMarker(lng, lat) {
      if (this.marker) {
        this.marker.setMap(null);
      }
      this.marker = new TMap.MultiMarker({
        id: "marker-layer",
        map: this.map,
        styles: {
          marker: new TMap.MarkerStyle({
            width: 25,
            height: 35,
            anchor: { x: 16, y: 32 },
            src:
              "https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png",
          }),
        },
        geometries: [
          {
            id: "demo",
            styleId: "marker",
            position: new TMap.LatLng(lat, lng),
          },
        ],
      });
    },

    getNowPlace({ lng, lat }) {
      getMapGeocoder({
        lng,
        lat,
      }).then((result) => {
        if (result.message.code == 0) {
          let tempObj = result.data;
          this.checked = {
            id: "",
            adcode: tempObj.ad_info.adcode,
            city: tempObj.ad_info.city,
            district: tempObj.ad_info.district,
            province: tempObj.ad_info.province,
            location: `${lat},${lng}`,
            addressLocal: tempObj.formatted_addresses.standard_address,
          };
          this.keyword = tempObj.address
          this.search()
        } else {
          Toast(res.message.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.amap-choose {
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99999;
  ::v-deep input {
    background-color: #fff;
    color: #999999;
    border-color: transparent;
  }
  .top-button {
    z-index: 9999;
    top: 0;
    box-sizing: border-box;
    padding: 0.32rem;
    position: fixed;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    z-index: 100;
    .cancel {
      // color: white;
    }
    .conform {
      background-color: #2255d9;
      color: white;
      padding: 0.1067rem 0.1867rem;
      border-radius: 0.1067rem;
    }
  }

  .map-box {
    // background-color: pink;
    #container {
      z-index: 2;
      position: relative;
      width: 100vw;
      height: 58vh;
    }
    ::v-deep .rotate-circle {
      display: none !important;
    }
    ::v-deep .tmap-zoom-control {
      display: none !important;
    }
  }

  .content {
    position: fixed;
    bottom: 0;
    border-radius: 0.32rem 0.32rem 0 0;
    height: 42%;
    width: 100%;
    background: white;
    box-sizing: border-box;
    padding: 0.32rem;
    .search {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      & > div {
        width: 88%;
        height: 0.8533rem;
        border-bottom: 1px solid #eeeeee;
        // background: #f4f4f4;
        border-radius: 0.1867rem;
        box-sizing: border-box;
        padding: 0.1067rem 0.32rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        image {
          width: 0.4rem;
          height: 0.3333rem;
        }
        input {
          margin-left: 0.1067rem;
          flex: 1;
        }
      }
    }

    .main {
      margin-top: 0.26667rem;
      height: calc(100% - 1.1733rem);
      // background: pink;
      overflow-y: auto;
      & > div {
        box-sizing: border-box;
        padding: 0.2667rem;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .detail {
          color: #707070;
        }
      }
    }
  }
}
</style>
